// src/components/template/Header.js
import { useAuthentication } from '../auth/hooks/useAuthentication';
import HeaderConnected from './HeaderConnected';
import HeaderNotConnected from './HeaderNotConnected';
import { AppBar } from "@mui/material";
import * as React from "react";
import { useDarkMode } from "../darkMode/hook/useDarkMode";
import { useUserInfo } from "../userInfo/hooks/useUserInfo";
import { useLocation } from 'react-router-dom';

const Header = () => {
    const { isAuthenticated, isLoading, keycloakLogin, keycloakLogout } = useAuthentication();
    const { isLoadingProfile, profil } = useUserInfo();
    const { mode } = useDarkMode();
    const location = useLocation();

    if (location.pathname === '/registration-success') {
        return null;
    }

    if (isLoading || isLoadingProfile || (isAuthenticated && !profil)) {
        return <AppBar
            sx={{
                backgroundColor: {
                    xs: mode.settings.footerBackgroundColor,
                    md: mode.settings.footerBackgroundColor,
                    lg: mode.darkMode
                        ? mode.settings.backgroundColor
                        : isAuthenticated
                            ? '#F0F2F8'
                            : isLoading ? '#F0F2F8' : '#FFFFFF',
                },
                height: '95px',
                boxShadow: 'none !important'
            }}>
        </AppBar>
    }

    return isAuthenticated ? (
        <HeaderConnected keycloakLogout={keycloakLogout} />
    ) : (
        <HeaderNotConnected keycloakLogin={keycloakLogin} />
    );
};

export default Header;